import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {LoaderOverlayComponent} from './shared/components/loader-overlay.component';
import { AppTrackingService } from './shared/tracking/app-tracking.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoaderOverlayComponent],
  templateUrl: './app.html',
  styleUrl: '../assets/scss/app.scss',
  standalone: true,
})
export class App implements OnInit {
  protected readonly title = signal('ttpoi');

  private readonly tracking = inject(AppTrackingService);

  ngOnInit(): void {
    // Browser-only GA4 route tracking for the main SSR app.
    // No-ops during SSR (guarded inside the service).
    this.tracking.init();
  }
}
